module.exports = __webpack_public_path__ + "img/32.ff430e1e.jpg";